import axios from "../../privateApi";

export const patchUser = (data) => axios.patch("users", data);
